import {
  SignUpUserRequestDto,
  type AccountResponseDto,
  SignUpUserResponseDto,
  AccountPublicResponseDto,
  AccountSettingResponseDto,
} from 'types/types';
import { request as __request } from '../request/request';
import { OpenAPI } from '../request/open-api';
import axios from 'axios';
import { CancelablePromise } from 'api/request/cancelable-promise';

export function getAccountByEmail(accountEmail: string) {
  return __request<AccountResponseDto>(OpenAPI, {
    method: 'GET',
    url: '/accounts/search-email/{account_email}',
    path: {
      account_email: accountEmail,
    },
    errors: {
      400: `Bad Request`,
      401: `Unauthorized`,
      403: `Forbidden`,
      404: `Not Found`,
      422: `Unprocessable Entity`,
    },
  });
}

export function getAccountById(id: string) {
  return __request<AccountResponseDto>(OpenAPI, {
    method: 'GET',
    url: '/accounts/search-pk/{id}',
    path: {
      id,
    },
    errors: {
      400: `Bad Request`,
      401: `Unauthorized`,
      403: `Forbidden`,
      404: `Not Found`,
      422: `Unprocessable Entity`,
    },
  });
}

export function createUser(userData: SignUpUserRequestDto) {
  return __request<SignUpUserResponseDto>(OpenAPI, {
    method: 'POST',
    url: '/accounts',
    body: userData,
    errors: {
      400: `Bad Request`,
      401: `Unauthorized`,
      403: `Forbidden`,
      404: `Not Found`,
      422: `Unprocessable Entity`,
    },
  });
}

export function setTokenHeader(token: string) {
  axios.defaults.headers.common.Authorization = 'Bearer ' + token;
}

export const getPublicAccountData = (patientId: string): CancelablePromise<AccountPublicResponseDto> => {
  return __request(OpenAPI, {
    method: 'GET',
    url: '/public/account/{patientId}',
    errors: {
      400: `Bad Request`,
      401: `Unauthorized`,
      403: `Forbidden`,
      404: `Not Found`,
      422: `Unprocessable Entity`,
    },
    path: {
      patientId,
    },
  });
};

export const getAccountSettings = (accountId: string): CancelablePromise<AccountSettingResponseDto[]> => {
  return __request(OpenAPI, {
    method: 'GET',
    url: '/accounts/{accountId}/settings',
    errors: {
      400: `Bad Request`,
      401: `Unauthorized`,
      403: `Forbidden`,
      404: `Not Found`,
      422: `Unprocessable Entity`,
    },
    path: {
      accountId,
    },
  });
};
